import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useLang } from '../i18n'

export function ForgotPasswordPage() {
  const { t } = useLang()
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const r = await fetch('/api/auth/forgot', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      })
      if (r.ok) {
        setSent(true)
      } else {
        const err = await r.json()
        setError(err?.error?.message || t('errorGeneric'))
      }
    } catch {
      setError(t('errorGeneric'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <div style={{
        width: '340px', padding: '32px', border: '1px solid var(--border)',
        borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', background: 'var(--bg-surface)',
      }}>
        <h2 style={{ margin: '0 0 24px 0', fontSize: '20px', color: 'var(--text-primary)', textAlign: 'center' }}>
          {t('forgotPasswordTitle')}
        </h2>

        {sent ? (
          <div>
            <p style={{ color: 'var(--success)', fontSize: '14px', marginBottom: '16px' }}>
              {t('forgotPasswordSent')}
            </p>
            <Link to="/login" style={{ color: 'var(--text-primary)', fontSize: '13px' }}>
              {t('backToLogin')}
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {error && (
              <div style={{
                padding: '10px 12px', background: 'var(--danger-bg)', border: '1px solid var(--danger)',
                borderRadius: '4px', color: 'var(--danger)', fontSize: '13px',
              }}>
                {error}
              </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>{t('email')}</label>
              <input
                type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder={t('email')} required
                style={{ padding: '8px 10px', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '14px' }}
              />
            </div>

            <button type="submit" disabled={loading} style={{
              padding: '10px', background: loading ? 'var(--text-muted)' : 'var(--accent)',
              color: 'var(--accent-contrast)', border: 'none', borderRadius: '4px', fontSize: '14px',
              fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
            }}>
              {loading ? t('loading') : t('forgotPasswordSubmit')}
            </button>

            <div style={{ textAlign: 'center' }}>
              <Link to="/login" style={{ fontSize: '13px', color: 'var(--text-primary)', textDecoration: 'underline' }}>
                {t('backToLogin')}
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}
